<template>
    <div>
        <v-btn
            x-small
            depressed
            outlined
            color="primary"
            class="mb-2"
            @click="dialog = true"
        >
            <v-icon small left>mdi-account</v-icon>
            {{ title }}
        </v-btn>
        <v-dialog v-model="dialog" max-width="700px">
            <v-card>
                <v-card-title class="d-flex justify-center">
                    <v-icon left>
                        mdi-account
                    </v-icon>
                    <h3 class="font-weight-light text-capitalize">{{ title }} - {{ capitalizeString(expeditionUserInfo.name) }}</h3>
                </v-card-title>
                <v-card-text class="text-center" v-if="expeditionUserInfo && expeditionUserInfo.contactInfo">
                    <h3 class="font-weight-light mt-4 mb-2"><strong>Dirección</strong></h3>
                    <span class="font-weight-light grey--text">{{ capitalizeString(formatAddress(expeditionUserInfo.addressInfo)) }}</span>
                    <h3 class="font-weight-light mt-4 mb-2"><strong>Información de Contacto</strong></h3>
                    <div class="d-flex flex-column justify-center align-center">
                        <span class="font-weight-light grey--text"><strong>Email:</strong> {{ expeditionUserInfo.contactInfo.email }}</span>
                        <span class="font-weight-light grey--text"><strong>Teléfono:</strong> {{ expeditionUserInfo.contactInfo.phone }}</span>
                    </div>
                    <h3 class="font-weight-light mt-4 mb-2"><strong>Documento</strong></h3>
                    <div class="d-flex flex-column justify-center align-center">
                        <span class="font-weight-light grey--text"><strong>Tipo:</strong> {{ expeditionUserInfo.document.type }} - <strong>ID:</strong> {{ expeditionUserInfo.document.id }}</span>
                        <span class="font-weight-light grey--text"><strong>Fecha de Expiración:</strong> {{ expeditionUserInfo.document.expirationDate ? expeditionUserInfo.document.expirationDate : 'No disponible' }}</span>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn depressed text color="red" @click="dialog=false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        dialog: false,
    }),
    props: {
        expeditionUserInfo: {
            type: Object,
            required: true,
        },
        title: {
            type: String,
            default: 'Información del Usuario',
        },
    },
    methods: {
        capitalizeString(string) {
            try{
                
                return string.split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
            } catch (error) {
                return string;
            }
        },
        formatAddress(address) {
            if (!address) return '';
            const components = ["streetName", "streetNumber", "city", "state", "postalCode", "country"];

            const formattedAddress = components
                .map(component => address[component]?.trim())
                .filter(Boolean)
                .join(', ');

            return formattedAddress.replace(/,+/g, ', ');
        }
    },
}
</script>
